export default "__VITE_ASSET__BIkdv6rW__"